/* 布局 */
//前台
import Layout from "@views/layout";

const pointsconfigRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "pointsconfig",
            name: "POINTSCONFIG",
            meta: {
                title: "基础积分项目",
                sort: 1,
            },
            component: () => import("@views/business/pointsconfig/index.vue"),
            redirect: {
                name: "POINTSCONFIG_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "POINTSCONFIG_LIST",
                    meta: {
                        title: "基础积分项目",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/pointsconfig/list.vue"),
                },
                                                {
                    path: "edit",
                    name: "POINTSCONFIG_EDIT",
                    meta: {
                        title: "编辑积分配置表",
                        parentPath: '/business/pointsconfig/list',
                        operate: true,
                    },
                    component: () => import("@views/business/pointsconfig/form.vue"),
                },
                                        ],
    },


        ],
};

export default pointsconfigRouter;
